module.exports = __webpack_public_path__ + "static/media/ic_encryption.6898f686.svg";